import escapeStringRegexp from "escape-string-regexp"

// note forward slash symbol is added below
const acceptedSymbols = "! # $ % & ' ( ) * + , - : ; < = > ? @ [ ] ^ _ { | } ~".split(" ")

const lookAhead = (requirement: string) => `(?=.*${requirement})`

const symbols = `[\\/${escapeStringRegexp(acceptedSymbols.join(""))}]`

export const passwordPattern = `^${lookAhead("\\d")}${lookAhead("[a-z]")}${lookAhead("[A-Z]")}${lookAhead(symbols)}.{8,}$`
